import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export interface FileCheckResult {
  success: boolean;
  case_id: string;
  errors: string[];
}

interface FileCheckerState {
  loading: boolean;
  error: string | null;
  result: FileCheckResult | null;
}

const initialState: FileCheckerState = {
  loading: false,
  error: null,
  result: null,
};

export const checkCaseFiles = createAsyncThunk<
  FileCheckResult,
  { case_id: string },
  { rejectValue: string }
>("fileChecker/checkCaseFiles", async ({ case_id }, { rejectWithValue }) => {
  try {
    const res = await api.get("/file-checker/status", {
      params: { case_id },
      withCredentials: true,
    });

    return res.data as FileCheckResult;
  } catch (err: any) {
    const msg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
      "Failed to check case files";
    return rejectWithValue(msg);
  }
});

const fileCheckerSlice = createSlice({
  name: "fileChecker",
  initialState,
  reducers: {
    resetFileCheckerState: (state) => {
      state.loading = false;
      state.error = null;
      state.result = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkCaseFiles.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.result = null;
      })
      .addCase(checkCaseFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(checkCaseFiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to check case files";
      });
  },
});

export const { resetFileCheckerState } = fileCheckerSlice.actions;
export default fileCheckerSlice.reducer;
